<template>
  <div class="about-page">
    <div class="card">
      <h2>服务说明</h2>
      <p class="p">「乒乓球培训」为培训机构提供课时管理工具，主要功能如下：</p>

      <div class="section">
        <h3>1. 刷脸签到（学员/家长）</h3>
        <p>打开「刷脸签到」，正对摄像头完成人脸识别，系统自动记录签到并扣除 1 课时。</p>
      </div>
      <div class="section">
        <h3>2. 我的课时</h3>
        <p>家长登录后可查看孩子的大课与小课剩余课时及历史记录。</p>
      </div>
      <div class="section">
        <h3>3. 管理后台（机构管理员）</h3>
        <p>管理员登录后可：报名录入、学生管理、录入人脸、课时充值/扣减、小课管理等。</p>
      </div>
      <div class="section">
        <h3>4. 技术支持</h3>
        <p>如遇问题请联系您所在的培训机构。</p>
      </div>

      <router-link to="/privacy" class="link">查看《用户隐私保护指引》</router-link>
      <router-link to="/" class="link back">返回首页</router-link>
    </div>
  </div>
</template>

<script>
export default { name: 'About' }
</script>

<style scoped>
.about-page { max-width: 640px; margin: 0 auto; padding: 16px; min-height: 100vh; background: #f5f5f5; }
.card { background: #fff; border-radius: 12px; padding: 24px; box-shadow: 0 2px 8px rgba(0,0,0,0.06); }
h2 { margin-bottom: 16px; }
.p { color: #666; font-size: 14px; line-height: 1.6; margin-bottom: 16px; }
.section { margin-bottom: 20px; }
.section h3 { font-size: 15px; margin-bottom: 8px; color: #333; }
.section p { color: #666; font-size: 14px; line-height: 1.6; }
.link { display: block; color: #409EFF; font-size: 14px; margin-top: 12px; text-decoration: none; }
.back { margin-top: 8px; }
</style>
